import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ConfirmationDataInstanceToken, ConfirmationDataInterface } from './interfaces/confirmation-data.interface';

@Injectable({
    providedIn: 'root',
})
export class ConfirmationCanDeactivateGuard implements CanDeactivate<ConfirmationComponent> {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        @Inject(ConfirmationDataInstanceToken) private readonly confirmationService: ConfirmationDataInterface,
    ) {}

    public canDeactivate(
        component: ConfirmationComponent,
        /* eslint-disable @typescript-eslint/no-unused-vars */
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.log.debug(
            `ConfirmationCanDeactivateGuard: canDeactivate: Triggering auto-save of confirmation for notification '${component.model.notificationIdentifier.toString()}'`,
        );

        if (!component.model.isSubmitted) {
            this.confirmationService
                .saveConfirmation(component.model)
                .pipe(
                    take(1),
                    catchError((err) => {
                        this.log.error(
                            `ConfirmationCanDeactivateGuard: canDeactivate: ERROR Saving confirmation for notification '${component.model.notificationIdentifier.toString()}' FAILED: ${JSON.stringify(err)}`,
                        );
                        return of(undefined);
                    }),
                )
                .subscribe();
        }

        return true;
    }
}
